import React from 'react';
import { Autocomplete, TextField, FormHelperText, Box } from '@mui/material';
import { useSelector } from 'react-redux';
import { useUser } from '@/providers';

import STORAGE_TYPES from '@/components/jobs/JobForm/storageTypes';
import THIRD_PARTY_TYPES from '@/components/jobs/JobForm/thirdPartyTypes';
import JOB_TYPES from '@/components/jobs/types';

export default function OutputTypeField({
  value,
  setValue,
  setChanged,
  edit,
  type,
}) {
  const user = useUser();
  const project_credentials = useSelector((state) => state.projectCredentials);

  const project_key_types = project_credentials
    ? project_credentials.map((key) => key.type)
    : [];

  const allOptions =
    JOB_TYPES.NOTEBOOK.value === type
      ? [THIRD_PARTY_TYPES.REGIONAL]
      : STORAGE_TYPES.output;

  const selectedOption =
    allOptions.find((type) => type.value === value) || null;

  const handleChange = (event, newValue) => {
    const newValueStr = newValue ? newValue.value : null;
    if (newValueStr !== value) {
      setChanged();
    }
    setValue(newValueStr);
  };

  const getOptionDisabled = (option) => {
    return !(
      option.alwaysEnabled ||
      project_key_types.includes(option.value) ||
      (option.cloudbender_required && user.cloudbender_enabled)
    );
  };

  const isDisabled = edit && JOB_TYPES.NOTEBOOK.value !== type;

  return (
    <Box>
      <Autocomplete
        id='output_type'
        options={allOptions}
        getOptionLabel={(option) => option.text}
        getOptionDisabled={getOptionDisabled}
        isOptionEqualToValue={(option, value) => option?.value === value?.value}
        value={selectedOption}
        onChange={handleChange}
        disabled={isDisabled}
        renderInput={(params) => (
          <TextField
            {...params}
            label='Output Type'
            aria-describedby='output-type-helper-text'
          />
        )}
        renderOption={(props, option) => (
          <li {...props} key={option.value}>
            {option.text}
          </li>
        )}
      />
      <FormHelperText id='output-type-helper-text'>
        Select the output storage type
      </FormHelperText>
    </Box>
  );
}
